export default __webpack_public_path__ + "static/media/13d.809b7223.png";